<button
  aria-label="toggle sidebar"
  class="no-style burger-wrapper"
  [disabled]="!isEnabled()"
  (click)="onSidebarToggle()">
  @if (isEnabled()) {
    <div
      class="menu-burger"
      id="menu-bar-close-open">
      @if (isSidebarVisible()) {
        <mat-icon
          animate.enter="fade-in"
          animate.leave="fade-out">
          close
        </mat-icon>
      }
      @if (!isSidebarVisible()) {
        <mat-icon
          animate.enter="fade-in"
          animate.leave="fade-out">
          menu
        </mat-icon>
      }
    </div>
  }
</button>
@if (isEnabled()) {
  <customer-app-collapsed-bar
    role="menu"
    [titles]="titles()"
    (toggleItem)="onSidebarToggle($event)"></customer-app-collapsed-bar>
}
<div
  class="components"
  role="menu">
  <ng-content></ng-content>
</div>
